import { TRAMITE_STYLE } from "../lib/format";

export function StatusBadge({ estatus, testId }) {
  const s = TRAMITE_STYLE[estatus] || TRAMITE_STYLE["No iniciado"];
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${s.bg} ${s.text}`}>
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.dot }} />
      {estatus}
    </span>
  );
}

export function ProgressBar({ value, className = "" }) {
  const color = value >= 100 ? "#059669" : value >= 50 ? "#00A3B5" : value > 0 ? "#F59E0B" : "#CBD5E1";
  return (
    <div className={`h-1.5 rounded-full bg-slate-100 overflow-hidden ${className}`}>
      <div className="h-full rounded-full transition-[width] duration-700 ease-out"
        style={{ width: `${value}%`, background: color }} />
    </div>
  );
}

export function Ring({ value, size = 88, stroke = 8, color = "#00A3B5", label }) {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#E2E8F0" strokeWidth={stroke} />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth={stroke}
          strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - (c * value) / 100}
          style={{ transition: "stroke-dashoffset 1s ease-out" }} />
      </svg>
      <div className="absolute text-center">
        <p className="font-display font-bold text-lg leading-none text-[#002B49]">{value}%</p>
        {label && <p className="text-[9px] uppercase tracking-wider text-slate-500 mt-0.5">{label}</p>}
      </div>
    </div>
  );
}

export function SectionTitle({ children, right }) {
  return (
    <div className="flex items-center justify-between mb-4">
      <h3 className="font-display font-bold text-[#002B49] text-lg">{children}</h3>
      {right}
    </div>
  );
}

export function Card({ children, className = "", testId }) {
  return (
    <div data-testid={testId} className={`bg-white border border-slate-200/70 rounded-lg shadow-sm ${className}`}>
      {children}
    </div>
  );
}
